import $ from 'jquery';
import { window, exists } from 'browser-monads'
import Common from '../Common.js';
//import '/src/views/Common/jquery.js'


class Auth {
    static CB_API_URL = Common.getEndpoint();

    constructor(storage) {
        this.CB_API_URL = Auth.CB_API_URL;

        if(typeof storage === "undefined" || storage === null) {
            this.storage = window.localStorage
        } else {
            this.storage = storage
        }
    }

    login(email, password, callback) {
        this.isLoggedInHandler((isLoggedIn) => {
            if(isLoggedIn) {
                callback(true)
            } else {
                let postData = {email: email, password: password}
 
                $.post(this.CB_API_URL + "edge-rest-auth/login/", postData, (jsonResponse, status, xhr) => {
                    console.log("Received response: " + xhr.status)
                    if(xhr.status === 200) {
                        this.setLocalToken(jsonResponse["key"])
                        
                        this.checkServerTokenHandler(() => {})
                        callback(true)
                        return
                    } else {
                        callback(false)
                        return
                    }
                }).fail((jsonResponse, status, xhr) => {
                    console.log("Received response: " + status)
                    callback(false)
                    return
                });
            }
        })
    }

    logout(callback) {
        this.isLoggedInHandler((isLoggedIn) => {
            if(!isLoggedIn) {
                callback(true)
            } else {
                let postData = {}
                $.post(this.CB_API_URL + "edge-rest-auth/logout/", postData, (jsonResponse, status, xhr) => {
                    if(xhr.status === 200) {
                        localStorage.removeItem('tk');
                        localStorage.removeItem('user_id');
                        callback(true)
                    } else {
                        callback(false)
                    }
                }).fail((jsonResponse, status, xhr) => {
                    console.log("Received response: " + status)
                    callback(false)
                    return
                });;
            }
        })
    }

    getLocalToken() {
        return this.storage.getItem('tk');
    }

    setLocalToken(token) {
        this.storage.setItem('tk', token);
    }

    getUserId() {
        return this.storage.getItem('user_id');
    }

    setUserId(userId) {
        this.storage.setItem('user_id', userId)
    }

    checkServerTokenHandler(callback) {
        // true -> success
        // false -> failed
        let token = this.getLocalToken()

        if(token === null) {
            callback(false)
            return
        }

        if(exists(window)) {
            $.ajax({
                url: this.CB_API_URL + "edge-users/token/",
                type: "GET",
                beforeSend: function(xhr){xhr.setRequestHeader('Authorization', 'Token ' + token);},
                success: (jsonResponse, status, xhr) => {
                    if(xhr.status === 401) {
                        console.log(xhr.status)
                        callback(false)
                        return
                    } else if (xhr.status === 200) {
                        this.setUserId(jsonResponse["user_id"]);
                        callback(true)
                        return
                    } else {
                        console.log(xhr.status)
                        callback(false)
                        return
                    }
                },
                error: (jsonResponse, status, xhr) => {
                    console.log(xhr.status)
                    callback(false)
                    return
                }
            });
        }
    }

    isLoggedInHandler(callback) {
        this.checkServerTokenHandler((isLoggedIn) => {
            callback(isLoggedIn)
        })
    }

    getUserInfo(callback) {
        let token = this.getLocalToken()

        if(token === null) {
            callback(null, false)
            return
        }

        let userId = this.getUserId()

        if(userId === null) {
            callback(null, false)
        }

        $.ajax({
            url: this.CB_API_URL + "edge-users/" + userId + "/",
            type: "GET",
            beforeSend: function(xhr){xhr.setRequestHeader('Authorization', 'Token ' + token);},
            success: (jsonResponse, status, xhr) => {
                if(xhr.status === 401) {
                    callback(null, false)
                    return
                } else if (xhr.status === 200) {
                    callback(jsonResponse, true)
                    return
                } else {
                    callback(null, false)
                    return
                }
            },
            error: (jsonResponse, status, xhr) => {
                callback(null, false)
                return
            }
        });
    }

    resetPassword(oldPassword, password1, password2, callback) {
        let token = this.getLocalToken()

        if(token === null) {
            callback(null, false)
            return
        }

        $.ajax({
            url: this.CB_API_URL + "edge-rest-auth/password/change/",
            type: "POST",
            data: { 
                old_password: oldPassword,
                new_password1: password1,
                new_password2: password2,
            },
            beforeSend: function(xhr){xhr.setRequestHeader('Authorization', 'Token ' + token);},
            success: (jsonResponse, status, xhr) => {
                if(xhr.status === 401) {
                    callback(false, jsonResponse)
                    return
                } else if (xhr.status === 200) {
                    callback(true, jsonResponse)
                    return
                } else {
                    callback(false, jsonResponse)
                    return
                }
            },
            error: (jsonResponse, status, xhr) => {
                callback(false, jsonResponse)
                return
            }
        });
    }

    signup(data, callback) {
        this.isLoggedInHandler((isLoggedIn) => {
            if(isLoggedIn) {
                alert('You are current logged in. Please logout to signup.')
                return
            } else {
                let postData = { 
                    email: data.email, 
                    password1: data.password1,
                    password2: data.password2,
                    username: data.username,
                    first_name: data.firstName,
                    last_name: data.lastName,
                    phone: data.phone
                }

                console.log(postData)
 
                $.post(this.CB_API_URL + "edge-rest-auth/registration/", postData, (jsonResponse, status, xhr) => {
                    console.log("Received response: " + xhr.status)
                    if(xhr.status === 201) {
                        callback(true, jsonResponse)
                        return
                    } else {
                        callback(false, jsonResponse)
                        return
                    }
                }).fail((jsonResponse, status, xhr) => {
                    console.log("Received response: " + status)
                    callback(false, jsonResponse)
                    return
                });
            }
        })
    }
}


export default Auth